import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
declare var $: any;

@Injectable({
    providedIn: 'root'
})
export class Library {
    constructor(
        private snackBar: MatSnackBar
    ) {}

    showloading() {
        // tslint:disable-next-line:max-line-length
        const html = `<div class="app-loading"><svg class="spinner" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/></svg></div>`;
        $('#app-loading').html(html);
    }

    hideloading() {
        $('#app-loading').html('');
    }

    showNotify(message) {
        this.snackBar.open(message, 'OK', {
            duration: 1000 * 1000,
        });
    }

}
